import { render, staticRenderFns } from "./enquiry-list.vue?vue&type=template&id=d477e476&"
import script from "./enquiry-list.vue?vue&type=script&lang=ts&"
export * from "./enquiry-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports